import React from "react"
import Svg from "../../utils/Svg"
import Path from "../../utils/Path"

const YouTubeSvg = ({ color = "primary", ...rest }) => {
  return (
    <Svg
      fill="none"
      width="33"
      height="33"
      viewBox="1.5 -8 12 28"
      xmlns="http://www.w3.org/2000/svg"
      {...rest}
    >
      <Path
        fill={color}
        d="m15.6 2.10039c-.2-.7-.7-1.199999-1.4-1.399999-1.2-.3-6.30001-.3-6.30001-.3s-4.99998 0-6.29998.3c-.700004.2-1.200013.699999-1.400013 1.399999-.20000005 1.3-.199997 3.9-.199997 3.9s.00000304 2.6.300003 3.9c.2.70001.699994 1.20001 1.399997 1.40001 1.2.3 6.3.3 6.3.3s5 0 6.3-.3c.7-.2 1.2-.7 1.4-1.40001.3-1.3.3-3.9.3-3.9s0-2.6-.4-3.9zm-9.20001 6.3v-4.8l4.20001 2.4z"
      />
    </Svg>
  )
}

export default YouTubeSvg
